export const googleServices = {
    'googleCaptcha' : '6LcxjsQUAAAAABc398zNZe3c0d85Uv3jH6_C00IG',
    'googleCaptchaV3': '6LfebD4pAAAAADIO50XRWpx2JzWyyCLPGwrpUsOq'
}